<template lang="pug">
v-card
  .pa-4
    h2.text-center.mb-4 Welcome to Nation.better!
    p.text-center(v-text="text2")
    .btns
      .d-flex.justify-center
        v-btn(color="primary", @click="$emit('next')") {{ btnLable2 }}
</template>

<script>
export default {
  data: () => ({
    text1:
      "We are here to help you to go " +
      "through UK immigration process as smooth as possible, " +
      "please answer all following questions.",
    text2:
      "We are here to help you to apply for a Sponsor Licence.\n" +
      "If you wish to apply under Skilled Worker " +
      "(T2) category - please press the button to proceed.",
    btnLable1: "ok",
    btnLable2: "skilled worker (t2)",
  }),
};
</script>
